import { render, staticRenderFns } from "./EditUserNotifications.vue?vue&type=template&id=229e8484"
import script from "./EditUserNotifications.vue?vue&type=script&lang=js"
export * from "./EditUserNotifications.vue?vue&type=script&lang=js"
import style0 from "./EditUserNotifications.vue?vue&type=style&index=0&id=229e8484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports